export function isMobileDevice() {
    const isDesktop1 = /Windows|Macintosh|Linux/.test(navigator.userAgent);

    const isDesktop2 = /Win|Mac|Linux/.test(navigator.platform);

    const isMobile1 = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const isMobile2 = (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) !== null

    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad'];
    const isMobile3 = mobileKeywords.some(keyword => userAgent.indexOf(keyword) !== -1);

    const ratio = window.innerWidth / window.innerHeight;
    const mobileRatioThreshold = 0.6;

    const isMobile4 = navigator.userAgentData?.mobile ?? ratio < mobileRatioThreshold;

    if (!isDesktop1 || !isDesktop2 || isMobile1 || isMobile2 || isMobile3 || isMobile4) {
        return true;
    } else {
        return false;
    }
};